import { createContext } from "react";

// Carries an import chosen on the events page through the new-event wizard.
export const InitialAttendeeImportContext = createContext(null);
